import { render, staticRenderFns } from "./search.vue?vue&type=template&id=8d39127c&scoped=true"
import script from "./search.vue?vue&type=script&lang=ts"
export * from "./search.vue?vue&type=script&lang=ts"
import style0 from "./search.vue?vue&type=style&index=0&id=8d39127c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d39127c",
  null
  
)

export default component.exports